window.dynamicHeader = function () {
    return {
        hidden: false,
        scrolled: false,
        lastScroll: window.scrollY,
        scrollUpDelta: 0,
        stickyLimit: 200,
        thresholdUp: 100,
        init() {
            this.scrolled = window.scrollY > 0;
            window.addEventListener('scroll', () => {
                const current = window.scrollY;
                const delta = current - this.lastScroll;

                this.scrolled = current > 0;

                if (current <= this.stickyLimit) {
                    this.hidden = false;
                } else {
                    if (delta > 0) {
                        // Down
                        this.scrollUpDelta = 0;
                        this.hidden = true;
                    } else {
                        // Up
                        this.scrollUpDelta += Math.abs(delta);
                        if (this.scrollUpDelta >= this.thresholdUp) {
                            this.hidden = false;
                        }
                    }
                }

                this.lastScroll = current;
            }, { passive: true });
        },
    };
}

/**
 * Mega menu (desktop, xl and up): a click opens and closes a panel, and a mouse also opens it on hover. Touch and
 * keyboard keep the click only. Hovering waits a moment before it opens a panel, so moving across the menu doesn't
 * flash one, and before it closes one, so the pointer can travel from the button to the panel; with a panel open,
 * hovering another button switches at once. A click on a panel the mouse opened keeps it open (a second click
 * closes it), and a panel opened with a click stays open when the mouse leaves.
 */
window.megaMenu = function () {
    return {
        menu: null,
        // The columns the panel shows: the open menu's, and the last one's while the panel fades out
        panel: null,
        hovered: false,
        timer: null,
        openDelay: 120,
        closeDelay: 200,
        init() {
            this.$watch('menu', (menu) => {
                if (menu !== null) {
                    this.panel = menu;
                }
            });
        },
        toggle(id) {
            clearTimeout(this.timer);
            this.menu = this.menu === id && !this.hovered ? null : id;
            this.hovered = false;
        },
        hoverOpen(event, id) {
            if (event.pointerType !== 'mouse') {
                return;
            }
            clearTimeout(this.timer);
            if (this.menu === id) {
                return;
            }
            this.timer = setTimeout(() => {
                this.menu = id;
                this.hovered = true;
            }, this.menu === null ? this.openDelay : 0);
        },
        hoverStay(event) {
            if (event.pointerType === 'mouse') {
                clearTimeout(this.timer);
            }
        },
        hoverClose(event) {
            if (event.pointerType !== 'mouse') {
                return;
            }
            // Also cancels a panel that was about to open
            clearTimeout(this.timer);
            if (this.menu !== null && this.hovered) {
                this.timer = setTimeout(() => this.close(), this.closeDelay);
            }
        },
        close() {
            clearTimeout(this.timer);
            this.menu = null;
            this.hovered = false;
        },
    };
}
